import { render, staticRenderFns } from "./ShowBell.vue?vue&type=template&id=88cc346a&scoped=true"
import script from "./ShowBell.vue?vue&type=script&lang=js"
export * from "./ShowBell.vue?vue&type=script&lang=js"
import style0 from "./ShowBell.vue?vue&type=style&index=0&id=88cc346a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc346a",
  null
  
)

export default component.exports